const localstorageKey = 'neptune-sso-workspace';

export function getWorkspaceNameFromLocalstorage(): string {
  return localStorage.getItem(localstorageKey) || '';
}

export function persistSsoWorkspaceNameInLocalstorage(workspace: string) {
  localStorage.setItem(localstorageKey, workspace);
}

export function dropSsoWorkspaceNameFromLocalstorage() {
  localStorage.removeItem(localstorageKey);
}
